import { render } from "./payment-pix.vue?vue&type=template&id=3e6f57f6"
import script from "./payment-pix.vue?vue&type=script&lang=js"
export * from "./payment-pix.vue?vue&type=script&lang=js"

import exportComponent from "/builds/commerce/central/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__